import * as _ from 'lodash';
import { rgbaToHex } from '../../../components/CanvasEditor/helpers/fabricHelpers';
import { colorOptions } from '../../../components/CanvasEditor/components/Color/colorOptions';

const initialState = {
  uploads: {},
  pinned_tasks: {},
  pinned_plans: {},
  pinned_specifications: {},
  annotations: {},
};

const _transformData = (data, pinned_tasks) => {
  data.objects = data.objects.map((obj) => {
    if (obj.taskID && pinned_tasks[obj.taskID]) {
      return { ...obj, ...pinned_tasks[obj.taskID] };
    }
    return obj;
  });

  return data;
};

const _filterData = (data, filter_params) => {
  data = _.cloneDeep(data);

  const filterMap = {
    creator: 'userID',
    task_title: 'taskID',
    object_type: 'objectType',
    task_status: 'status',
    task_priority: 'priority',
    task_stage_discipline: 'stage_disciplines',
    task_assignee: 'assignee',
    stroke_color: 'stroke',
  };

  data.objects = _.filter(data.objects, (obj) => {
    return _.every(filterMap, (objKey, filterKey) => {
      const filterValue = _.get(filter_params, `filter.${filterKey}`);

      if (!filterValue) return true;
      const filterIds = _.split(filterValue, '|');

      // Only for object colors
      if (filterKey === 'stroke_color') {
        return _.some(filterIds, (colorName) => {
          const colorHex = _.find(colorOptions, {
            key: colorName,
          })?.hex;

          if (!colorHex) return false;

          const objHex = rgbaToHex(obj[objKey]);

          return objHex === colorHex;
        });
      }

      // If object has multiple values
      if (Array.isArray(obj[objKey])) {
        return _.some(obj[objKey], (val) => _.includes(filterIds, String(val)));
      }

      return _.includes(filterIds, String(obj[objKey]));
    });
  });

  return data;
};

export default function reducer(state = initialState, action) {
  let data;

  switch (action.type) {
    case 'table.working_set_plans/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.working_set_plans/LIST_PLAN_VERSION_TASKS_SUCCESS':
      return {
        ...state,
        pinned_tasks: action.response.data,
      };
    case 'table.working_set_plans/LIST_PINNED_PLAN_VERSION_SPECIFICATIONS_SUCCESS':
      return {
        ...state,
        pinned_specifications: action.response.data,
      };
    case 'table.working_set_plans/LIST_PLAN_VERSION_PLANS_SUCCESS':
      return {
        ...state,
        pinned_plans: action.response.data,
      };
    case 'table.working_set_plans/READ_WORKING_SET_PLAN_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };
    case 'table.working_set_plans/READ_PLAN_VERSION_ANNOTATION_SUCCESS':
      return {
        ...state,

        annotations: _filterData(
          _transformData(action.response.data, state.pinned_tasks),
          _.pickBy(state, (value, key) => {
            return _.startsWith(key, 'filter.');
          })
        ),

        initialAnnotations: action.response.data,
      };
    case 'table.working_set_plans/READ_PLAN_VERSION_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    case 'table.working_set_plans/FILTER_PLAN_VERSION_ANNOTATIONS':
      return {
        ...state,
        annotations: _filterData(
          state.initialAnnotations,
          _.pickBy(state, (value, key) => {
            return _.startsWith(key, 'filter.');
          }),
          state.pinned_tasks
        ),
        initialAnnotations: state.initialAnnotations,
      };
    case 'table.working_set_plans/LIST_WORKING_SET_PLANS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };

    case 'table.working_set_plans/UPLOAD_NEW_PLAN_VERSION_PROGRESS':
      data = {
        ...state,
      };

      _.set(
        data,
        'uploads.' + action.id,
        parseFloat(
          (action.progress.loaded / action.progress.total) * 100
        ).toFixed(1)
      );

      return data;
    case 'table.working_set_plans/REMOVE_NEW_PLAN_VERSION_UPLOAD':
      data = {
        ...state,
      };

      _.unset(data, 'uploads.' + action.plan_id);

      return data;

    case 'table.working_set_plans/LIST_WORKING_SET_PLANS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    default:
      return state;
  }
}
